// extracted by mini-css-extract-plugin
module.exports = {"container":"_2N3y6","content":"_1CTFK","header":"_2bMEN","iconBack":"_21_Oa","title":"_21wem","subTitle":"_2AZGa","separator":"_11tQl","inputWrapper":"_2T82f"};